// extracted by mini-css-extract-plugin
export var contentCard = "bx_d0";
export var gridBase = "bx_dX";
export var gridElement = "bx_d1";
export var gridTumbleIn = "bx_d2";
export var heightAuto = "bx_dZ";
export var heightFull = "bx_dY";